module.exports = __webpack_public_path__ + "af7ad1b2de5986b85bebd270fa4adf5a.MP3";